<template>
  <div>
    <multiselect 
        class="" :value="sortByValue" 
        :show-labels="false" 
        deselect-label="Can't remove this value" 
        track-by="value" label="name" 
        placeholder="Select one" 
        :options="options" :searchable="false" :allow-empty="false"
        @select="$emit('selected', $event)"
    >
      <template slot="singleLabel" slot-scope="{ option }">Sort by <strong>{{ option.name }} <i v-if="option.direction === 'asc'" class="fas fa-sort-amount-up"></i><i v-else class="fas fa-sort-amount-down"></i></strong></template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "SortByDropdown",

  props: {
    value: String
  },
  
  data() {
    return {
      options: [
        {name: 'Interest Rate', direction: 'asc', value: 'interestRate ASC', sortBy: {"field": "initialInterestRate", "order": 1}},
        {name: 'APRC', direction: 'asc', value: 'aprc ASC', sortBy: {"field": "aprc", "order": 1}},
        {name: 'Monthly Cost', direction: 'asc', value: 'monthlyCost ASC', sortBy: {"field": "estimatedInitialMonthlyCost", "order": 1}},
        {name: 'Total Cost', direction: 'asc', value: 'totalCost ASC', sortBy: {"field": "estimatedFullTermCost", "order": 1}},
        {name: 'Loan-to-value', direction: 'desc', value: 'ltv ASC', sortBy: {"field": "ltvMaxPercent", "order": 0}},
        {name: 'Lender', direction: 'asc', value: 'lender ASC', sortBy: {"field": "lender", "order": 1}}
      ]
      // { "monthlyPayment", "Monthly Payment" }, { "interestRate", "Interest Rate" },
      // { "ltv", "Loan to Value (LTV)" }, { "totalCost", "Total cost"}, {"lender", "Lender"}
    }
  },
  
  computed: {
    sortByValue() {
      return this.options.find(i => i.value === this.value) ?? null;
    }
  },

  components: {
    Multiselect
  }
}
</script>

<style scoped>

</style>